module.exports = __webpack_public_path__ + "img/image_medal.d50faaae.png";